import React from 'react';

export interface SportsBettingContextProps {
  maxMainMarkets: number,
  maxFilterButtons: number,
  selectedSport: number,
  setSelectedSport: Function
}

const SportsBettingContext = React.createContext<Partial<SportsBettingContextProps>>({
  maxMainMarkets: 1,
  maxFilterButtons: 2,
  selectedSport: null,
  setSelectedSport: () => {}
});

export default SportsBettingContext;
